import BaseCollection from "lib/collection";
import BaseModel from "lib/model";

const GalleryHotspotModel = BaseModel.extend({
    mainIndex: "ref",

    props: {
        ref: "objectId",
        x: { type: "number", required: true },
        y: { type: "number", required: true },
    },
});

const GalleryImageModel = BaseModel.extend({
    mainIndex: "_id",

    props: {
        _id: "objectId",
        hero: "boolean",
        name: "string",
        date: "string",
        title: "string",
        caption: "string",
        link: "string",
    },

    collections: {
        products: GalleryHotspotModel,
    },
});

const GalleryModel = BaseModel.extend({
    props: {
        _id: "objectId",

        type: {
            type: "string",
            values: ["campaign", "press", "video", "assets"],
            required: true,
        },

        active: "boolean",
        name: "string",
        description: "string",

        video: "string",
        video_thumbnail: "string",
        employee_code: "string",

        created_on: "date",
        modified_on: "date",
    },

    collections: {
        images: GalleryImageModel,
    },
});

export default BaseCollection.extend({
    mainIndex: "_id",

    url() {
        return `${this.parent.url()}/galleries`;
    },

    getByType(type) {
        return this.filter(function (element) {
            return element.type === type;
        });
    },

    getActive() {
        return this.filter(function (element) {
            return element.active;
        });
    },

    model: GalleryModel,
});
